module.exports = __webpack_public_path__ + "img/cost.6a862aa1.svg";